import React from "react";

function SendArrow({color}) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.83203 14.1654L14.1654 5.83203M14.1654 5.83203H7.4987M14.1654 5.83203V12.4987"
        stroke={color ? color : "white"}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export default SendArrow;
